import React,{useState,useEffect} from 'react';
import {Offcanvas, Form, Button, Image} from 'react-bootstrap';
import { useLanguage } from '../../i18n/LanguageContext';

function ChakraInfo(props){
  const { t } = useLanguage();
  const [show, setShow] = useState(props.show);
  const [chakraColors, setColors] = useState(["red","orange","#ffe082","#4caf50","cornflowerblue","#673ab7","purple"]);
 
  useEffect(() => {
    
  },[] );

  function handleClose(){
    setShow(false);
    props.onHide(false);
  } 

  function getModal(){
    const chakraList = t('chakraSpread.chakras');
    const chakras = Array.isArray(chakraList) ? chakraList : [];

    return (
      <Offcanvas className="semitext" show={show} onHide={handleClose} {...props} placement={'end'}>
      <Offcanvas.Header style={{paddingTop:'calc(env(safe-area-inset-top))'}} closeButton>
        <Offcanvas.Title><div style={{fontWeight:'bold'}}>{t('chakraSpread.infoTitle')}</div></Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body style={{paddingTop:0}}>
      <div style={{overflowY:'auto', height:'100%'}}>
        <div>{t('chakraSpread.instruction')}</div>
        <p></p>
        <p style={{fontWeight:'bold'}}>{t('chakraSpread.sevenChakras')}</p>
        {chakras.map((c, idx) => (
          <p key={idx}>
            <span style={{fontWeight:'bold', color: chakraColors[idx] || 'white'}}>{c.name} </span>
            {c.desc}
          </p>
        ))}
        <p><Image
            src="/graphics/7chakras.jpg"
            alt={t('chakraSpread.sevenChakras')}
            fluid
            style={{ maxWidth: '100%', marginBottom: '16px', borderRadius: '8px' }}
          /></p>
      </div>
      </Offcanvas.Body>
      </Offcanvas>
    )
  }

  const handleShow = () => setShow(true);


  return (
    getModal()
  )
};

export default ChakraInfo;